<div class="panel-bottom" [ngClass]="{ active: active }">
  <div class="open-action-panel">
    <span class="closed" (click)="toggleActive()"> ¿Cuál Fran quieres? + </span>
    <span class="opened" (click)="toggleActive()">
      <mat-icon class="icon-close">close</mat-icon>
    </span>
  </div>
  <div class="opened-content">
    <mat-nav-list class="que-fran-list">
      <a mat-list-item [routerLink]="'/director'" (click)="toggleActive()">
        DIRECTOR
      </a>
      <a mat-list-item [routerLink]="'/actor'" (click)="toggleActive()">
        ACTOR
      </a>
      <a mat-list-item [routerLink]="'/comediante'" (click)="toggleActive()">
        COMEDIANTE
      </a>
      <a mat-list-item [routerLink]="'/voice-artist'" (click)="toggleActive()">
        VOICE ARTIST
      </a>
      <a mat-list-item [routerLink]="'/conferencista'" (click)="toggleActive()">
        CONFERENCISTA
      </a>
      <a mat-list-item [routerLink]="'/sircomedia'" (click)="toggleActive()">
        SIRCOMEDIA
      </a>
    </mat-nav-list>
  </div>
</div>
